import { getLibUrl } from 'lib/base';
import { ExpressionConfigs } from './config';

const getExpressionIconUrl = (path, name, postfix) => {
  // const url = MM.core.getRoot(`${path}${name}${postfix}`, 'base')
  const url = getLibUrl(`${path}${name}${postfix}`);
  return url;
};

//在光标处插入文字
function insertAtCursor(txtarea, text) {
  var scrollPos = txtarea.scrollTop,
    strPos = 0,
    br =
      txtarea.selectionStart || txtarea.selectionStart == '0'
        ? 'ff'
        : document.selection
        ? 'ie'
        : false;

  if (br == 'ie') {
    txtarea.focus();
    var range = document.selection.createRange();
    range.moveStart('character', -txtarea.value.length);
    strPos = range.text.length;
  } else if (br == 'ff') {
    strPos = txtarea.selectionStart;
  }

  var front = txtarea.value.substring(0, strPos),
    back = txtarea.value.substring(strPos, txtarea.value.length);

  txtarea.value = front + text + back;
  strPos = strPos + text.length;

  if (br == 'ie') {
    txtarea.focus();
    var range = document.selection.createRange();
    range.moveStart('character', -txtarea.value.length);
    range.moveStart('character', strPos);
    range.moveEnd('character', 0);
    range.select();
  } else if (br == 'ff') {
    txtarea.selectionStart = strPos;
    txtarea.selectionEnd = strPos;
    txtarea.focus();
  }

  txtarea.scrollTop = scrollPos;
}

/**
 * 判断是否有某个表情
 * @param  {String}  text 文本
 * @param  {String}  type svip/level
 * @return {Boolean}      [description]
 */
function hasExp(text, type) {
  type = type || 'common';

  const validExpressionConfigs = ExpressionConfigs.filter(
    (v) => type === v.name,
  );
  const { list, prefix } = validExpressionConfigs[0].content;

  var flag = false;

  for (var i = 0; i < list.length; i++) {
    const name = list[i];
    if (text.indexOf(prefix + name) > -1) {
      flag = true;
      break;
    }
  }

  return flag;
}

/**
 * 解析表情，依据等级
 * @param  {String}  text  文本
 */
function analysizeExpression(text, opt = {}) {
  opt = Object.assign(
    {
      level: 0,
      isStar: 0,
    },
    opt,
  );
  const { level } = opt;
  const validExpressionConfigs = ExpressionConfigs.filter(
    (v) => level >= v.level,
  );

  for (var i = 0; i < validExpressionConfigs.length; i++) {
    const type = validExpressionConfigs[i].name;
    const { list, prefix, postfix, directory } =
      validExpressionConfigs[i].content;

    list.forEach((name) => {
      const tempReg = new RegExp(prefix + name, 'g');
      text = text.replace(
        tempReg,
        `<img class="exp-img exp-img-${type}" title="${name}" alt="${name}" src="${getExpressionIconUrl(
          directory,
          name,
          postfix,
        )}" />`,
      );
    });
  }

  return text;
}

export { getExpressionIconUrl, insertAtCursor, analysizeExpression, hasExp };
